export default __webpack_public_path__ + "static/media/contacts.025997e8.svg";